import React, { useEffect, useState } from 'react'
import { launchInfo } from '../../constants/launchInfo'
import styled from '@emotion/styled/macro'


const TimeComponent = styled("div")`
  display: flex;
  flex-direction: row;
  div{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  h1 {
    margin: 0 1em 0 1em;
  }
  h3 {
    margin: 0 1em 0 1em;
  }
`


const CountDownTimer = () => {
  const [countDownDate, setCountDownDate] = useState(launchInfo.launchTime);
  const [state, setState] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    setInterval(() => setNewTime(), 1000);
  }, []);

  const setNewTime = () => {
    if (countDownDate) {
      const currentTime = new Date().getTime();

      const distanceToDate = countDownDate - currentTime;

      let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      let minutes = Math.floor(
        (distanceToDate % (1000 * 60 * 60)) / (1000 * 60),
      );
      let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

      const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];

      days = `${days}`;
      if (numbersToAddZeroTo.includes(hours)) {
        hours = `0${hours}`;
      } else if (numbersToAddZeroTo.includes(minutes)) {
        minutes = `0${minutes}`;
      } else if (numbersToAddZeroTo.includes(seconds)) {
        seconds = `0${seconds}`;
      }

      if(days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0){
        location.reload();
      }
      setState({ days: days, hours: hours, minutes, seconds });
    }
  };


  return (
    <TimeComponent>
      <div>
        <h1>{state.days}</h1>
        <h3>Days</h3>
      </div>
      <div>
        <h1>{state.hours}</h1>
        <h3>Hours</h3>
      </div>
      <div>
        <h1>{state.minutes}</h1>
        <h3>Minutes</h3>
      </div>
      <div>
        <h1>{state.seconds}</h1>
        <h3>Seconds</h3>
      </div>
    </TimeComponent>
  )
}

export default CountDownTimer
